import { request } from '@/services/request';
import type { ReplyData, ReqParams } from '@/pages/api/login';
import type * as IUser from '@/pages/api/user/getUser';

export function login(params: ReqParams): Promise<ReplyData> {
  return request({
    method: 'post',
    url: '/api/login',
    data: params,
  }).then((res) => res.data);
}

export function getUser(params: IUser.ReqParams): Promise<IUser.ReplyData> {
  return request({
    method: 'post',
    url: '/api/user/getUser',
    data: params,
  }).then((res) => res.data);
}
